import { useEffect, useState } from "react";
import { type UserAndPopulationStatsForOneJournal } from "../../../../common/types/index.js";
import StatsPage from "../../components/UserDashboard/StatsPage.js";
import SignInPage from "../../components/UserDashboard/SignInPage.js";

interface UserDashboardProps {
  readonly isLoggedIn: boolean;
  readonly setLoggedIn: (val: boolean) => void;
}

const UserDashboard = ({
  isLoggedIn: loggedIn,
  setLoggedIn,
}: UserDashboardProps) => {
  const [userStats, setUserStats] = useState<
    UserAndPopulationStatsForOneJournal[]
  >([]);

  useEffect(() => {
    if (!loggedIn) {
      return;
    }

    void fetch("/api/user/stats", {
      credentials: "include",
    }).then((res) => {
      if (res.ok) {
        void res.json().then((stats) => {
          setUserStats(stats as UserAndPopulationStatsForOneJournal[]);
        });
      }
    });
  }, [loggedIn]);

  const sumStats = (userData: UserAndPopulationStatsForOneJournal[]) => {
    if (userData.length > 0) {
      const totalJournals = userData.length;

      const totalPapersSubmitted = userData.reduce((acc, x) => {
        return acc + x.userStats.distinctManuscripts;
      }, 0);

      let totalPapersReceivingInitialRR = 0;
      for (const data of userData) {
        const userStats = data.userStats;
        if (userStats.pctReceivedRevisionOnInitialSub) {
          totalPapersReceivingInitialRR +=
            (userStats.pctReceivedRevisionOnInitialSub / 100) *
            userStats.distinctManuscripts;
        }
      }

      const averageRandR =
        Math.round(totalPapersReceivingInitialRR / totalPapersSubmitted) * 100;

      let totalDaysWaitingForFirstReview = 0;
      for (const data of userData) {
        const userStats = data.userStats;
        if (userStats.avgDaysToFirstDecision) {
          totalDaysWaitingForFirstReview +=
            userStats.avgDaysToFirstDecision * userStats.distinctManuscripts;
        }
      }

      return {
        totalDays: totalDaysWaitingForFirstReview,
        totalJournals: totalJournals,
        averageRandR: averageRandR,
        totalPapers: totalPapersSubmitted,
      };
    }

    return {
      totalDays: 0,
      totalJournals: 0,
      averageRandR: 0,
      totalPapers: 0,
    };
  };

  const result = sumStats(userStats);

  return (
    <>
      {loggedIn ? (
        <StatsPage userStats={userStats} result={result} />
      ) : (
        <SignInPage />
      )}
    </>
  );
};

export default UserDashboard;
